var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNdz(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    fill: "#622fba",
    fillRule: "nonzero",
    r: 16
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.586 17.376c-.087.027-.171.06-.253.098l-3.676-3.821a1.91 1.91 0 00-1.14-2.794V8.186l-.984-.55 2.273-1.315a2.384 2.384 0 012.388 0l4.519 2.616-1.786 1.033a1.911 1.911 0 00-2.686 1.747 1.91 1.91 0 001.345 1.824zm1.138 0V13.54a1.91 1.91 0 001.092-2.773l2.03-1.174.97.56A2.372 2.372 0 0125 12.207v7.586c0 .846-.451 1.628-1.185 2.053l-4.09 2.368v-3.192a1.91 1.91 0 00-.001-3.646zm-2.227.869a1.91 1.91 0 001.089 2.777v3.851l-1.392.806a2.384 2.384 0 01-2.388 0L9.94 22.863l1.828-1.428a1.91 1.91 0 001.231.447 1.911 1.911 0 001.914-1.91 1.91 1.91 0 00-1.397-1.838v-3.598c.105-.029.207-.067.304-.113zm-5.118-.079a1.91 1.91 0 00-1.226 2.308L8.882 22.25l-.697-.403A2.372 2.372 0 017 19.793v-7.586c0-.846.451-1.628 1.185-2.053l3.205-1.856.99.553v2.04a1.91 1.91 0 00-.001 3.613zM13 13.523a.827.827 0 11-.002-1.653.827.827 0 01.002 1.653zm0 7.275a.827.827 0 11-.002-1.653.827.827 0 01.002 1.653zm6.155-8.255a.827.827 0 11-.002-1.653.827.827 0 01.002 1.653zm0 7.482a.827.827 0 11-.002-1.654.827.827 0 01.002 1.654z",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNdz);
export default __webpack_public_path__ + "static/media/ndz.74b0fc869a7dab52358007a71899279f.svg";
export { ForwardRef as ReactComponent };